import React, { useEffect, useRef, useState } from 'react';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import { statusChangeDataType } from '../../../_common/types';
import StatusChangeReasonModal from './statusChangeReason.modal';
import { useAssestStatuesSelector } from '../../../store/selectors/masterSelector';

type AssetStatusProps = {
    asset: any
    onUpdate?: (data: any) => void,
    canChange?: boolean
};


const AssetStatus: React.FC<AssetStatusProps> = ({ asset, onUpdate, canChange }) => {
    const assetsAPI = useAssetsApi();
    const [statusChangeData, setStatusChangeData] = useState<statusChangeDataType | null>(null);
    const statusChangeReasonModalRef: any = useRef()

    const statusList = useAssestStatuesSelector();


    const GetAssetStatusList = () => {
        const payload = {};
        assetsAPI.GetAssetStatusList(payload, (resp: any) => {
            let deptlist: any = [];
            //console.log("resp.assetStatusList.filter((o:any) => o.isVisible)x", resp.assetStatusList.filter((o:any) => o.isVisible));
            resp.assetStatusList.filter((o: any) => o.isVisible).map((facilist: any) => {
                console.log("Exec x =>");
                deptlist.push({
                    label: facilist.statusName,
                    value: facilist.statusID,
                });
            });
            //setstatusList(deptlist);
        },
            (error: any) => {
                console.log("error =>", error);
            }
        );
    };

    useEffect(() => {
        if (!statusList || statusList.length === 0) {
            GetAssetStatusList();
        }
    }, [statusList]);

    return (
        <div className='flex items-center gap-2 h-full'>
            <div className='w-[0.5rem] h-[0.5rem] rounded-full flex-shrink-0' style={{ backgroundColor: asset.assetStatusColourCode || asset.colourCode || '#333333' }}></div>
            <select disabled={!canChange}
                className="status-dropdown flex-grow"
                value={statusChangeData ? statusChangeData.status.id : asset.statusID}
                onChange={(e) => {
                    if (!canChange) {
                        return;
                    } else {
                        setStatusChangeData({
                            assetID: asset.assetID,
                            status: {
                                id: e.target.value,
                                label: e.target.options[e.target.selectedIndex].text
                            }
                        });
                        statusChangeReasonModalRef?.current?.showModal();
                    }

                }}
            >
                {statusList?.map((status: any) => {
                    return (
                        <option value={status.value} selected={asset.statusID == status.value}>{status.label}</option>
                    )
                })}
            </select>
            <StatusChangeReasonModal
                _ref={statusChangeReasonModalRef}
                onUpdate={onUpdate}
                onCancel={() => { setStatusChangeData(null) }}
                data={statusChangeData}
            />
        </div>
    )
};

export default AssetStatus;